import Search from "../../../assets/icon/NewsIcons/NewsSearch"
import Calendar from "../../../assets/icon/NewsIcons/NewsCalendar"
import Clock from "../../../assets/icon/NewsIcons/NewsClock"
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const NavbarLeft = ({props}) => {
    const [showSearchBox,setShowSearchBox] = useState(false);
    const [currentTime, setCurrentTime] = useState("");
  const [currentDate, setCurrentDate] = useState("");
  const [search, setSearch] = useState("");
      let navigate = useNavigate();
  //  const GetData = async (search) => {
   
  //         const writersData = await axiosReq("Admins/GetArticleByCategorySlug?page=" + 1 + "&&pageSize=" + 100 + "&&search=" + search , "get");
  //         console.log(writersData)
  //         setData(writersData?.data)
          
  //     }
  useEffect(() => {
    // تابع برای گرفتن زمان و تاریخ
    const updateTime = () => {
      const now = new Date();
      const options = { timeZone: "Asia/Tehran", hour12: false };
      const timeFormatter = new Intl.DateTimeFormat("fa-IR", {
        ...options,
        hour: "2-digit",
        minute: "2-digit",
      });
      const dateFormatter = new Intl.DateTimeFormat("fa-IR", {
        ...options,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });

      setCurrentTime(timeFormatter.format(now));
      setCurrentDate(dateFormatter.format(now));
    };

    // اجرای تابع و به‌روزرسانی هر ثانیه
    updateTime();
    const intervalId = setInterval(updateTime, 1000);

    // پاک کردن تایمر هنگام خروج از کامپوننت
    return () => clearInterval(intervalId);
  }, []);

    return(
        <div className="flex justify-start items-center relative">
            <div className="flex justify-start items-center ">
            <div className="flex justify-start items-center">
                        <Calendar className="ml-2"/>
                        <p className="text-white border-l-[1px] pl-2 font-IRANYekanMedium text-[14px]">
                        {currentDate}
                        </p>

                    </div>
                    <div className="flex justify-start items-center mr-[14px]">
                        <Clock className="ml-2"/>
                        <p className="text-white font-IRANYekanMedium text-[14px]" >
                        {currentTime}
                        </p>
                    </div>
            </div>
            <button onClick={()=>setShowSearchBox(!showSearchBox)} className="flex justify-center items-center bg-nextColor w-[40px] h-[40px] mr-[14px] rounded-[50px] hover:bg-darkGray">
                    <Search fill={"#fff"}/>
                </button>
                {
                    showSearchBox ? 
                    <div className="absolute top-[110%] left-[2%] bg-[#fff] rounded-[10px] h-[40px] flex items-center px-[10px]">
                        <input onChange={(e)=>setSearch(e.target.value)} type="text" className="w-[350px]" placeholder="جستجو کنید ..."/>

                        <button onClick={()=>{navigate("/archiveAllNews/"+search);window.location.reload()}} className="mr-2">
                            <Search  fill={"#c1c1c1"}/>
                        </button>
                    </div>

                    :
                    null
                }
        </div>
    )
}

export default NavbarLeft;